import { PaletteMode } from '@mui/material';

export const getLoaderAnimationSrc = (themeMode: PaletteMode): string =>
  themeMode === 'dark'
    ? '/animations/loader-dark-theme.riv'
    : '/animations/loader-white-theme.riv';
